import styled from 'styled-components';

export const Wrapper = styled.div`
    background-color: #fff;
    padding: 12px;
    height: 106px;
    margin-bottom: 8px;
`;

export const Title = styled.div`
    font-size: 16px;
    font-weight: bold;
    color: #333;
`;

export const Content = styled.div``;

export const ItemWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 5px;
`;

export const Item = styled.div`
    font-size: 12px;
`;

export const ScoreWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;

export const Score = styled.div`
    font-size: 24px;
    font-weight: bold;
`;

export const ScoreText = styled.div`
    font-size: 12px;
    color: #999;
`;
